import React from "react";
import { noDataImage } from "../../assets/layout";
import { useUtils } from "../../customHooks/useUtils";

function NoContent({ message }: { message?: string }) {
  const { FEEDBACK_MESSAGES } = useUtils();
  return (
    <div className="flex flex-col  justify-center items-center h-full w-full">
      <img src={noDataImage} alt="No data" className="max-h-[150px]" />
      <span className="font-semibold">{message || FEEDBACK_MESSAGES.NO_DATA}</span>
    </div>
  );
}

export default NoContent;
